import { render } from "./CarouselView.vue?vue&type=template&id=e6d5098c"
import script from "./CarouselView.vue?vue&type=script&lang=js"
export * from "./CarouselView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__